// extracted by css-extract-rspack-plugin
export default {"root":"u1hT4","border":"HXaJN","editable":"ferAO","editing":"Pq81E","mirror":"zWkQn","textarea":"dbtBQ"};